<div class="logistic-partner-details">
    <!-- Loading State -->
    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading</span>
        </div>
    </div>

    <!-- Partner Details -->
    <div *ngIf="!loading && partner">
        <!-- Header with Status and Actions -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h3 class="mb-2">
                    <span *ngIf="isCompanyPartner()">Logistics Company</span>
                    <span *ngIf="isPrivatePartner()">Delivery Agent</span>
                </h3>
                <span [ngClass]="getStatusClass()">
                    {{ partner.status }}
                </span>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary" (click)="goBack()">
                    Back
                </button>
                <button class="btn btn-success" *ngIf="canApprove()" (click)="openApproveConfirmation(approveModal)">
                    Approve
                </button>
                <button class="btn btn-danger" *ngIf="canReject()" (click)="openRejectModal()">
                    Reject
                </button>
            </div>
        </div>

        <!-- Rejection Reason Card -->
        <div class="card mb-3" *ngIf="partner?.status === 'REJECTED' && partner?.reason">
            <div class="card-header bg-danger text-white">
                <h5>Rejection Reason</h5>
            </div>
            <div class="card-body">
                <p>{{ partner.reason }}</p>
            </div>
        </div>

        <!-- Company Partner Details -->
        <app-logistic-company-detail
            *ngIf="isCompanyPartner()"
            [partner]="partner">
        </app-logistic-company-detail>

        <!-- Private Partner Details -->
        <app-logistic-agent-detail
            *ngIf="isPrivatePartner()"
            [partner]="partner">
        </app-logistic-agent-detail>
    </div>
</div>

<!-- Approve Confirmation Modal -->
<ng-template #approveModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Confirm Approval</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to approve this logistic partner account?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
            Cancel
        </button>
        <button type="button" class="btn btn-success" (click)="confirmApprove()">
            Confirm Approval
        </button>
    </div>
</ng-template>
